import type { ThemeTokens } from '../types';
import { tealDark } from './tealDark';

/**
 * Blue Dark — spreads tealDark and overrides all brand + alpha tokens
 * with the blue (#2563eb) palette.
 */
export const blueDark: ThemeTokens = {
  ...tealDark,
  id: 'blue-dark',
  name: 'Blue Dark',

  // Brand
  primaryColor:    '#2563eb',
  primaryLight:    '#3b82f6',
  primaryDark:     '#1d4ed8',
  primarySubtle:   'rgba(37, 99, 235, 0.12)',
  hoverColor:      '#162035',
  activeColor:     '#1a2a4a',
  buttonFocusRing: 'rgba(37, 99, 235, 0.35)',
  shadowPrimary:   '0 4px 12px rgba(37, 99, 235, 0.25)',
  shadowPrimarySm: '0 1px 2px rgba(37, 99, 235, 0.20)',
  gradientBrand:   'linear-gradient(135deg, #2563eb 0%, #3a8d8d 100%)',
  gradientBrandR:  'linear-gradient(135deg, #3a8d8d 0%, #2563eb 100%)',
  gradientSubtle:  'linear-gradient(135deg, rgba(37,99,235,0.12) 0%, rgba(58,141,141,0.12) 100%)',
  infoColor:       '#2563eb',

  // Brand alpha
  primaryAlpha12: 'rgba(37, 99, 235, 0.12)',
  primaryAlpha15: 'rgba(37, 99, 235, 0.15)',
  primaryAlpha18: 'rgba(37, 99, 235, 0.18)',
  primaryAlpha20: 'rgba(37, 99, 235, 0.20)',
  primaryAlpha25: 'rgba(37, 99, 235, 0.25)',
  primaryAlpha30: 'rgba(37, 99, 235, 0.30)',
  primaryAlpha35: 'rgba(37, 99, 235, 0.35)',
  primaryAlpha40: 'rgba(37, 99, 235, 0.40)',
};
